import { render, staticRenderFns } from "./QuestionSeting.vue?vue&type=template&id=2e37fb96&scoped=true"
import script from "./QuestionSeting.vue?vue&type=script&lang=js"
export * from "./QuestionSeting.vue?vue&type=script&lang=js"
import style0 from "./QuestionSeting.vue?vue&type=style&index=0&id=2e37fb96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37fb96",
  null
  
)

export default component.exports